export default __webpack_public_path__ + "media/src/assets/images/novehicle-6924b461d1aa945c7c67ccf9d1dcf890.png";